import React from "react";

import FilterNumberProto from "../lib/number-field";

export default class FilterField2Number extends FilterNumberProto {

    constructor(filtersManager, field, initValue) {
        super(filtersManager, field, initValue, field.label);

        // this.filterConfig is field2 object

        this.field = this.filterConfig.fieldId;
        this.isCustomField = this.filterConfig.isCustom;
    }

    filterFunc(dataItem) {
        if (!this.value) return true;
        const value = dataItem[this.filterConfig.fieldId];

        // no value set
        if (!this.value.noValue && _.isNil(value)) return false;
        if (this.value.noValue && _.isNil(value)) return true;

        switch (this.value.curOption) {
            case 'greater': return _.isNil(this.value.greaterThan)  || value > this.value.greaterThan;
            case 'less':    return _.isNil(this.value.lessThan)     || value < this.value.lessThan;
            case 'between': return _.isNil(this.value.greaterThan)  || _.isNil(this.value.lessThan) || (value >= this.value.greaterThan && value <= this.value.lessThan);
        }

        return true;
    }

    filterFuncUniversal(dataItem) {return this.filterFunc(dataItem)}
}